var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"section-heading",class:{ 'section-heading--light': _vm.light }},[(_vm.eyebrow)?_c('p',{staticClass:"section-heading__eyebrow"},[_vm._v(_vm._s(_vm.eyebrow))]):_vm._e(),_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"section-heading__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }